<template>
  <div class="certificates">
    <div
      class="container-fluid page-header"
      :style="{ backgroundImage: 'url(' + require('@/assets/landing_page/buildings.jpg') +')' }"
    >
      <div class="row">
        <div class="col-12">
          <div class="page-title">Certidões</div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12">
                  <div class="col-12">
                    <b-table :items="data" hover :fields="fields" @row-clicked="selectItemTable">
                      <template v-slot:cell(name)="data">
                        <span>
                          <b>{{data.value}}</b>
                        </span>
                        <div v-if="data.item.link">
                          Verificar autenticidade:
                          <a
                            :href="getLink(data.item.link)"
                            class="primary-a"
                            target="_blank"
                          >{{data.item.link}}</a>
                        </div>
                      </template>
                      <template v-slot:cell(expiration_date)="data">{{formatDate(data.value)}}</template>
                    </b-table>
                    <div class="no-data" v-if="data.length == 0">
                      <span>Não existem certidões disponíveis</span>
                    </div>
                    <b-pagination
                      class="float-right"
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                      aria-controls="my-table"
                    ></b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { bus } from "@/main";
import helper from "@/imports/Helpers";
import moment from "moment";

export default {
  name: "certificates",
  data() {
    return {
      perPage: 6,
      currentPage: 1,
      rows: 0,
      data: [],
      fields: [
        { key: "name", label: "Descrição" },
        { key: "expiration_date", label: "Validade" }
      ]
    };
  },
  watch: {
    currentPage: {
      handler: function(value) {
        this.providerData();
      }
    }
  },
  mounted() {
    this.providerData();
  },
  methods: {
    filterTable() {
      this.currentPage = 1;
      this.providerData();
    },
    providerData: function() {
      let promise = axios
        .get(
          `${
            process.env.VUE_APP_API_HOST
          }/api/certificates_public?${this.urlBuild()}`
        )
        .then(response => {
          bus.$emit("changeLoading", false);
          this.rows = response.data.total;
          this.data = response.data.data;
        })
        .catch(error => {
          bus.$emit("changeLoading", false);
        });
    },
    urlBuild: function() {
      let url =
        "page[number]=" + this.currentPage + "&page[size]=" + this.perPage;
      return url;
    },
    formatDate: function(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    selectItemTable: function(record, index) {
      window.open(record.file_url);
    },
    getLink: function(link){
      if(link.includes('http')){
        return link;
      }
      
      return `http://${link}`;
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
</style>